export const TELEGRAM_BOT_URL = "https://t.me/finzypaybot";
export const TELEGRAM_NEWS_URL = "https://t.me/fwt_news";
